import { distributeQuantityAcrossRecommendations } from 'utils/distribute-quantity';

export type SavedAccessoryRowType = {
  productId: number;
  quantity: number;
  zoneUniqueId: string | null;
};

export type ZoneQuantityRowType = {
  zoneUniqueId: string;
  quantity: number;
};

export function resolveDuctingComponentZoneQuantities(
  totalQuantity: number,
  savedRows: SavedAccessoryRowType[],
  productId: number,
  condenserZoneUniqueIds: string[]
): ZoneQuantityRowType[] {
  if (totalQuantity <= 0) return [];
  const zoneIdSet = new Set(condenserZoneUniqueIds);
  const savedZoneRows = savedRows
    .filter((row) => row.productId === productId && row.quantity > 0)
    .flatMap((row) =>
      row.zoneUniqueId && zoneIdSet.has(row.zoneUniqueId)
        ? [{ zoneUniqueId: row.zoneUniqueId, quantity: row.quantity }]
        : []
    );
  if (savedZoneRows.length === 0) return [];

  const distributed = distributeQuantityAcrossRecommendations(
    totalQuantity,
    savedZoneRows.map((row) => ({
      uniqueId: row.zoneUniqueId,
      recommendedQuantity: row.quantity
    }))
  );
  const allocated = distributed.reduce((sum, entry) => sum + entry.quantity, 0);
  const leftover = totalQuantity - allocated;
  return distributed.map((entry, index) => ({
    zoneUniqueId: entry.uniqueId,
    quantity:
      index === distributed.length - 1
        ? entry.quantity + leftover
        : entry.quantity
  }));
}
